import { useState } from "react";
import { useHotkeys } from "react-hotkeys-hook";
import { HiOutlineExclamationCircle } from "react-icons/hi";
import { EMAIL_TYPE, ADMISSION_STATUS, ADMISSION_STATUS_REASON } from "../../utils";

const RejectModal = ({ setShowRejectModal, updateAdmission, nextAdmission, setEmailPreviewType, setShowEmailPreviewModal, admissionSelected, loading = false }) => {
  const [rejectReason, setRejectReason] = useState("");

  const onConfirm = async () => {
    await updateAdmission({ status: ADMISSION_STATUS.ARCHIVED, statusReason: ADMISSION_STATUS_REASON.REJECTED, rejectReason: rejectReason });
    setShowRejectModal(false);
    if (admissionSelected?.source !== "PATIENT" || !admissionSelected?.patient?.email) {
      return await nextAdmission();
    }
    setEmailPreviewType(EMAIL_TYPE.REJECTION);
    setShowEmailPreviewModal(true);
  };

  useHotkeys("mod+enter", onConfirm, { enabled: !!rejectReason.trim() && !loading, enableOnFormTags: true, preventDefault: true }, [onConfirm, rejectReason, loading]);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-[220] flex items-center justify-center">
      <div className="bg-white rounded-lg p-6 max-w-2xl w-full mx-4">
        <div className="flex items-center gap-3 mb-4">
          <div className="bg-red-100 rounded-full p-2">
            <HiOutlineExclamationCircle className="h-6 w-6 text-red-500" />
          </div>
          <h2 className="text-xl font-bold">Refuser le dossier</h2>
        </div>

        <div className="mb-4">
          <label htmlFor="rejectReason" className="block text-sm font-medium text-gray-700 mb-2">
            Motif du refus
          </label>
          <div className="relative">
            <textarea
              id="rejectReason"
              autoFocus
              rows={4}
              className="w-full border border-gray-300 rounded-md px-3 py-2"
              value={rejectReason}
              onChange={(e) => setRejectReason(e.target.value)}
              placeholder="Veuillez indiquer le motif du refus..."
            />
            {rejectReason && <div className="absolute left-2 -top-2 bg-white px-1 text-xs text-gray-500 pointer-events-none">Veuillez indiquer le motif du refus...</div>}
          </div>
        </div>

        <div className="flex justify-end gap-3">
          <button
            className="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors focus:ring-2 focus:ring-offset-1 focus:ring-primary-500 focus:outline-none"
            onClick={() => setShowRejectModal(false)}
            disabled={loading}
          >
            Annuler
          </button>
          <button
            className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed focus:ring-2 focus:ring-offset-1 focus:ring-red-500 focus:outline-none"
            disabled={!rejectReason.trim() || loading}
            onClick={onConfirm}
          >
            {loading ? "Chargement..." : "Confirmer le refus"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RejectModal;
